import '~/sass/pages/fullspec.scss';
import Swiper from 'swiper/js/swiper';

const { $ } = window;

const specSetLengh = $('.compare-headrow [data-set]').length;
console.log(specSetLengh);
if (specSetLengh === 2) {
  $('#sectionFullspecTable ').addClass('spec-set-length-2');
} else if (specSetLengh === 3) {
  $('#sectionFullspecTable ').addClass('spec-set-length-3');
}


const initWindowWidth = $(window).outerWidth();

// eslint-disable-next-line no-unused-vars
let swiperSpecUpgrad = null;

function checkLargeViewSize() {
  return window.innerWidth >= 1024;
}

function updateCompareLastColumn() {
  const resizeW = $(window).outerWidth();
  if (checkLargeViewSize() === true) {
    const intNowSet = 1;
    $('[data-set]').hide();
    $('[data-set]').removeClass('active');
    $(`[data-set=${intNowSet}]`).addClass('active');
    $(`[data-set=${intNowSet}]`).show();
    $(`[data-set=${intNowSet + 1}]`).show();
    $(`[data-set=${intNowSet + 2}]`).show();
    $('#button-prev').addClass('hide');
    $('#button-next').removeClass('hide');
  } else if (initWindowWidth !== resizeW) {
    const intNowSet = 1;
    console.log('mobile mode');
    $('[data-set]').hide();
    $('[data-set]').removeClass('active');
    $(`[data-set=${intNowSet}]`).addClass('active');
    $(`[data-set=${intNowSet}]`).show();
    $(`[data-set=${intNowSet + 1}]`).show();
    $('#button-prev').addClass('hide');
    $('#button-next').removeClass('hide');
  }
}

function initSpecUpgradeSwipers() {
  swiperSpecUpgrad = new Swiper('#specSet .swiper-container', {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '#specSet .swiper-button-next',
      prevEl: '#specSet .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function nextButtonChangeData() {
  $('#button-next').on('click', () => {
    const nowSet = $('.compare-content-col.active').attr('data-set');
    const intNowSet = parseInt(nowSet, 10);
    console.log(intNowSet + 1);

    $(`[data-set=${intNowSet}]`).hide();
    $(`[data-set=${intNowSet}]`).removeClass('active');
    $(`[data-set=${intNowSet + 1}]`).show();
    $(`[data-set=${intNowSet + 1}]`).addClass('active');
    $(`[data-set=${intNowSet + 2}]`).show();

    if (checkLargeViewSize() === true) {
      $(`[data-set=${intNowSet + 3}]`).show();

      if (intNowSet + 2 !== 1) {
        $('#button-prev').removeClass('hide');
      }
      if (intNowSet + 2 === specSetLengh - 1) {
        $('#button-next').addClass('hide');
      }
    } else {
      if (intNowSet + 1 !== 1) {
        $('#button-prev').removeClass('hide');
      }
      if (intNowSet + 1 === specSetLengh - 1) {
        $('#button-next').addClass('hide');
      }
    }
  });
}
function prevButtonChangeData() {
  $('#button-prev').on('click', () => {
    const nowSet = $('.compare-content-col.active').attr('data-set');
    const intNowSet = parseInt(nowSet, 10);
    console.log(intNowSet);

    $(`[data-set=${intNowSet}]`).removeClass('active');
    $(`[data-set=${intNowSet - 1}]`).show();
    $(`[data-set=${intNowSet - 1}]`).addClass('active');

    if (checkLargeViewSize() === true) {
      $(`[data-set=${intNowSet + 2}]`).hide();
    } else {
      $(`[data-set=${intNowSet + 1}]`).hide();
    }

    if (intNowSet - 1 === 1) {
      $('#button-prev').addClass('hide');
      if (specSetLengh === 3) {
        $('#button-next').removeClass('hide');
      }
    } else {
      $('#button-next').removeClass('hide');
    }
  });
}

$(document).ready(() => {
  // let isLargeView = checkLargeViewSize();
  updateCompareLastColumn();
  initSpecUpgradeSwipers();
  nextButtonChangeData();
  prevButtonChangeData();

  $('#global-header').scrollToFixed({
    limit: $('#compare-table-head').offset().top - $('#global-header').height(),
  });

  $('#compare-table-head').scrollToFixed();

  $('#spec-collapse-btn-open').on('click', () => {
    $('#compare-table-container .collapse').collapse('show');
  });
  $('#spec-collapse-btn-close').on('click', () => {
    $('#compare-table-container .collapse').collapse('hide');
  });

  $(window).resize(() => {
    // isLargeView = checkLargeViewSize();
    updateCompareLastColumn();
  });
});
